module.exports = __webpack_public_path__ + "static/music_main_lg-9a97ee4668515a3ef3d659699626b8ea.jpg";